import { render, staticRenderFns } from "./ProductTile.vue?vue&type=template&id=78a85b40&scoped=true"
import script from "./ProductTile.vue?vue&type=script&lang=js"
export * from "./ProductTile.vue?vue&type=script&lang=js"
import style0 from "./ProductTile.vue?vue&type=style&index=0&id=78a85b40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a85b40",
  null
  
)

export default component.exports